// extracted by mini-css-extract-plugin
export default {"icon":"icon--mmn5O"};